import React from 'react'
import styled from 'styled-components'
import { Link } from "gatsby"
import Img from 'gatsby-image'
import Tag from './common/Tag'
import { useMediaQuery } from 'react-responsive'

const StoryPreview = styled.div`
  width: 100%;
  margin: 12px 0;
  border-radius: 10px;
  background: white;
  height: max-content;
  position: relative;
  display: flex;

  .gatsby-image-wrapper {
    height: auto !important;
  }

  img {
    border-radius: 10px 0 0 10px;
    object-fit: cover;
    margin-bottom: 0;
    width: 30%;
  };

  > .story-info {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;

    > p {
      font-size: 0.8em;
      flex-grow: 1;
      margin-bottom: 5px;
    }
  };

  ${props => props.currentStory ?  'color: white; background: rgb(78, 82, 83); .preview-link {display: none};' : ''}
`

const StoryPreviewElement = (props) => {  
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1025px)' });
  const { excerpt, title, image, url, currentStory } = props;

  function limitExcerptMobile(excerpt) {
    return `${excerpt.slice(0,50)}...`
  }

  return(
    <StoryPreview currentStory={currentStory}>
      <Img fixed={image} />
      <div className="story-info">
        <h5>{title}{ currentStory ? <Tag>Current Story</Tag> : null }</h5>
        <p>{isTabletOrMobile ? limitExcerptMobile(excerpt) : excerpt}</p>
        <div style={{justifyContent: 'flex-end', display: 'flex'}}><Link className='preview-link' to={url}>Read Story</Link></div>
      </div>
    </StoryPreview>
  )
}

export default StoryPreviewElement